/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_IntegrationInputs */

const en_nav_section_integration = /** @type {(inputs: Nav_Section_IntegrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integration`)
};

/**
* | output |
* | --- |
* | "Integration" |
*
* @param {Nav_Section_IntegrationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_integration = /** @type {((inputs?: Nav_Section_IntegrationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_IntegrationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_section_integration(inputs)
});